import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetOdometerValueRequest, GetOdometerValueResponse, PostOdometrStartValueRequest } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { ChecklistService } from './../../../shared/services/checklist.service';
import { PostCheckListAnswerRequest } from './../../../shared/models/checklist.models';

@Component({
  templateUrl: 'input-odometer.component.html',
  styleUrls: ['./input-odometer.component.scss']
})
export class InputOdometerComponent implements OnInit {

  odometerResponse: GetOdometerValueResponse | null = null;
  startOdometerValue: number = 0;
  startHours: number = 0;
  startMinutes: number = 0;
  chosenDate: Date = new Date();
  isButtonDisabled: boolean = false;
  hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutes: number[] = Array.from({ length: 12 }, (_, i) => i * 5);
  loading: boolean = false;
  isMobile: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private checklistService: ChecklistService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadOdometer();
  }

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.checkIfMobile();
    }
  
    private checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

  loadOdometer(testTime?: Date) {
    this.loading = true;
    const startNewVoucherData =
      this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
    const request: GetOdometerValueRequest = {carId: startNewVoucherData.carId};
    this.courierService.getOdometrValue(request).subscribe((response: GetOdometerValueResponse) => {
      this.odometerResponse = response;
      this.startOdometerValue = this.odometerResponse.odometerValue.odometerEndVal ?? 0;
      
      const currentTime = new Date();
      this.startHours = currentTime.getHours();
      this.startMinutes = Math.round(currentTime.getMinutes() / 5.0) * 5;
      
      if (this.startMinutes === 60) {
        this.startMinutes = 0;
        this.startHours = (this.startHours + 1) % 24;
      }
      
      this.loading = false;
    });
  }
  dayBack() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() - 1);
    this.chosenDate = changedDate;
  }
  
  dayForward() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() + 1);
    this.chosenDate = changedDate;
  }
  
  startVoucher() {
    this.isButtonDisabled = true;
    const date = new Date(this.chosenDate);
    date.setHours(this.startHours);
    date.setMinutes(this.startMinutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.workStartTime = date; 
      const request: PostOdometrStartValueRequest = {
        odometerStartVal: this.startOdometerValue,
        carId: startNewVoucherData.carId,
        trailerId: startNewVoucherData.trailerId,
        clientsId: startNewVoucherData.clientId,
        routesId: startNewVoucherData.routeId,
        regionId: startNewVoucherData.regionId,
        workStartTime: date,
        createdFromWeb: true,
        isService: false
      };
      this.courierService.postStart(request).subscribe(() => {
        this.activeUserLocalDataService.setStartNewVoucherData(startNewVoucherData);
        this.postChecklist();
        this.router.navigate(['/voucher']);
      });
    }
  }

  postChecklist() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData && startNewVoucherData.checklistAnswers) {
        startNewVoucherData.checklistAnswers.forEach(answer => {
            const request: PostCheckListAnswerRequest = {
                checklistQuestionId: answer.checklistQuestionId,
                checklistAnswer: answer.checklistAnswer,
                comment: answer.comment,
                image: this.arrayBufferToBase64(answer.image)
            };
            this.checklistService.postCheckListAnswer(request).subscribe(response => {
            }, error => {
                console.error('Error posting checklist answer:', error);
            });
        });
    }
}

arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

  goback() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      if (startNewVoucherData.checklistAnswers.length > 0) {
        startNewVoucherData.checklistAnswers = [];
        this.router.navigate(['/checklist']);
      } else if (startNewVoucherData.routeId) {
        startNewVoucherData.routeId = undefined;
        this.router.navigate(['/pick-route']);
      } else if (startNewVoucherData.regionId) {
        startNewVoucherData.regionId = undefined;
        this.router.navigate(['/pick-region']);
      } else {
        startNewVoucherData.clientId = undefined;
        this.router.navigate(['/pick-client']);
      }
    }
  }
}